import { QuestionMarkOutlined } from '@mui/icons-material'

import ambient from './ambient'
import ammonia from './ammonia'
import boilerBlowdown from './boiler-blowdown'
import coldStorage from './cold-storage'
import fineWine from './fine-wine'
import firePump from './fire-pump'
import freezer from './freezer'
import gateway from './gateway'
import leakFreeze from './leak-freeze'
import moldConditions from './mold-conditions'
import pipe from './pipe'
import pipeFreeze from './pipe-freeze'
import powerOutage from './power-outage'
import refrigerator from './refrigerator'
import serverRoomMonitoring from './server-room-monitoring'
import ting from './ting'
import water from './water'
import waterShutoff from './water-shutoff'

const UseCaseIcon = ({ useCase, color = '#5B6271' }: { useCase: string; color?: string }) => {
  if (useCase === 'ambient') return ambient(color)
  if (useCase === 'ammonia') return ammonia(color)
  if (useCase === 'boiler-blowdown') return boilerBlowdown(color)
  if (useCase === 'cold-storage') return coldStorage(color)
  if (useCase === 'fine-wine') return fineWine(color)
  if (useCase === 'fire-pump') return firePump(color)
  if (useCase === 'freezer') return freezer(color)
  if (useCase === 'gateway') return gateway(color)
  if (useCase === 'leak-freeze') return leakFreeze(color)
  if (useCase === 'mold-conditions') return moldConditions(color)
  if (useCase === 'pipe') return pipe(color)
  if (useCase === 'pipe-freeze') return pipeFreeze(color)
  if (useCase === 'power-outage') return powerOutage(color)
  if (useCase === 'refrigerator') return refrigerator(color)
  if (useCase === 'server-room-monitoring') return serverRoomMonitoring(color)
  if (useCase === 'ting') return ting(color)
  if (useCase === 'water') return water(color)
  if (useCase === 'water-shutoff') return waterShutoff(color)
  return <QuestionMarkOutlined sx={{ color }} />
}

export default UseCaseIcon
